<template>
    <div class="about-container">
      <section id="career" class="info-section">
        <h2 class="section-title"><i class="fas fa-briefcase"></i> Career</h2>
        <div class="position-block">
          <div class="position-title">Assistant Economist</div>
          <div class="position-tags">
            <span class="position-tag">Data Analyst</span>
            <span class="position-tag">Marketing</span>
            <span class="position-tag">Meta Ads</span>
            <span class="position-tag">Leadership</span>
          </div>
          <p class="position-description">
            As an Assistant Economist at Verdi, I led marketing strategies that enhanced market presence and supported company growth through detailed analysis.
          </p>
          <div class="position-duration">2021-2022</div>
        </div>
        <!-- Add other positions as needed -->
      </section>
      
      <section id="education" class="info-section">
        <h2 class="section-title"><i class="fas fa-graduation-cap"></i> Education</h2>
        <div class="position-block">
          <div class="position-title">School of Computing</div>
          <p class="position-description">
            BSc in Computer Engineering
          </p>
          <div class="position-duration">2021-present</div>
        </div>
        <!-- Add other education entries as needed -->
      </section>
      
      <section id="certifications" class="info-section">
        <h2 class="section-title"><i class="fas fa-certificate"></i> Certifications</h2>
        <div class="position-block">
          <div class="position-title">IELTS</div>
          <p class="position-description">
            Certification in English Proficiency.
          </p>
          <div class="position-duration">Issued 2021</div>
        </div>
        <!-- Add other certifications as needed -->
      </section>
    </div>
    <footer>
        © 2024 Bakir Hamidovic
    </footer>
  </template>
  
  <script>
  import { VueMetaPlugin } from 'vue-meta';
  export default {
    name: "AboutPage",
    metaInfo: {
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0',
        },
      ],
    },
  };
  </script>
  
  <style scoped>
  .about-container {
    max-width: 800px;
    margin: auto;
    padding: 2rem 1rem;
  }
  
  .info-section {
  background-color: #fff;
  margin-bottom: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  position: relative;
  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Smooth transition for shadow and transform */
}

.info-section:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Increased shadow for "pop up" effect */
  transform: translateY(-5px); /* Slightly raise the section */
}
  
  .section-title {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #333;
    display: flex;
    align-items: center;
  }
  
  .section-title i {
    margin-right: 0.5rem;
  }
  
  .position-block {
    border-left: 4px solid #007bff;
    padding-left: 1rem;
    margin-bottom: 1rem;
  }
  
  .position-title {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .position-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 0.5rem 0;
  }
  
  .position-tag {
    background-color: #e1e1e1;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
    font-size: 0.875rem;
  }
  
  .position-description {
    font-size: 1rem;
    color: #555;
    margin: 0.5rem 0;
  }
  
  .position-duration {
    position: absolute;
    top: 2rem;
    right: 2rem;
    font-size: 0.875rem;
    color: #666;
  }

  footer {
  color: #333;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  position: static;
  bottom: 0;
}
  
  @media (max-width: 768px) {
    .about-container {
      max-width: fit-content;
      padding: 1.2rem;
    }
  
    .section-title {
      font-size: 1.4rem;
    }
  
    .position-title {
      font-size: 1.1rem;
    }
  }

  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css');
  </style>
  